/* unplugin-vue-components disabled */import { render } from "./fillcolor.vue?vue&type=template&id=6bf3aabd&scoped=true"
import script from "./fillcolor.vue?vue&type=script&lang=js"
export * from "./fillcolor.vue?vue&type=script&lang=js"

import "./fillcolor.vue?vue&type=style&index=0&id=6bf3aabd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf3aabd"]])

export default __exports__